<div class="p-d-flex p-ai-center">
  <span
    class="p-input-icon-left p-input-icon-right"
    [ngStyle]="{ width: width }"
  >
    <input
      #searchInput
      type="text"
      pInputText
      class="p-inputtext basin-width-100"
      [class.p-disabled]="disabled"
      [ngModel]="searchString"
      (ngModelChange)="searchChange($event)"
      [placeholder]="placeholder"
      (keyup.enter)="enterSearch()"
      (keydown)="onKeyDown($event)"
    />
    <i
      class="icon-search width-icon-content"
      [class.primary-color]="searchString != '' && searchString != null"
      (click)="enterSearch()"
      onKeyPress=""
      onKeyDown=""
      onKeyUp=""
    ></i>
    <i
      *ngIf="searchString != '' && searchString != null"
      class="icon-close x-hover"
      (click)="clearSearch()"
      onKeyPress=""
      onKeyDown=""
      onKeyUp=""
    ></i>

    <div #searchResultsPanel>
      <p-overlayPanel
        #searchPanel
        [showCloseIcon]="false"
        id="search-overlay-panel"
        styleClass="basin-m-0 basin-overflow-auto basin-px-0 basin-py-0 small-panel"
      >
        <ng-template pTemplate="content" class="basin-px-0 basin-py-1">
          <div
            class="basin-overflow-y-scroll max-panel"
            [style.max-height]="resultsMaxHeight"
            [style.width]="searchInput.offsetWidth + 'px'"
            *ngIf="resultView$ | async as results"
          >
            <div *ngIf="!searchResultsLoading">
              <div
                class="dropdown-item basin-px-3 basin-py-1"
                *ngFor="let item of results"
                (click)="selectResultFromOverlay(item)"
                onKeyPress="selectResultFromOverlay(item)"
              >
                <div class="list-item-text-box">
                  <div
                    class="basin-body line-height-normal primary-line basin-body-small"
                  >
                    {{ item.label }}
                  </div>
                </div>
              </div>
            </div>

            <div class="basin-px-3 basin-py-1" *ngIf="results.length === 0">
              <div class="list-item-text-box">
                <div class="basin-body line-height-normal primary-line">
                  {{
                    searchResultsLoading
                      ? 'Loading...'
                      : noSearchResultsFoundLabel
                  }}
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-overlayPanel>
    </div>
  </span>

  <basin-chip
    *ngFor="let filterChip of filterChips; index as i"
    [label]="filterChip"
    [removable]="true"
    [active]="checkIfActive(filterChip)"
    (activeChange)="turnOffChipFilter($event, filterChip)"
    [toggleType]="toggleableFilterChips ? 'toggle' : null"
    (removedChange)="removedChip(filterChip)"
    class="basin-mr-3"
    [class.basin-ml-5]="i == 0"
    style="display: block"
  ></basin-chip>
</div>
